mpangoApp.factory('Mtodo',['$http', function ($http) {
	return{
		getTasks : function  () {
			return $http.get('index.php/api/gettasks');
		},
		postTask : function(task) {
			return $http({
				method: 'POST',
				url: 'index.php/api/posttask',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':task}
			
			});
		},
		updateTask : function(tododata,formname) {
			return $http({
				method: 'POST',
				url: 'index.php/api/updatetask',
				headers: { 'Content-Type' : 'application/x-www-form-urlencoded' },
				params: {'data':tododata,'formname':formname}
			});
		},
		
	}
}]);